<template>
    <div>
      <!-- modal -->
      <b-modal
        id="patentStatusFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="patentStatusFormModal"
        :title=" $t('patentStatus.info')"
        :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')"
        cancel-variant="outline-secondary"
        @ok.prevent="addOrUpdate"
      >
        <validation-observer ref="simpleRules">
          <b-form>
            <label for="patent-status-name-input">{{ $t('patentStatus.name') }}</label>
            <b-form-group>
            <validation-provider
              #default="{ errors }"
              :name=" $t('patentStatus.name')"
              rules="required"
            >
            <b-form-input
              id="patent_status-name-input"
              v-model="patentStatusName"
              maxlength="50"
              size="sm"
              :state="errors.length > 0 ? false:null"
            />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          </b-form>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getPatentStatusList: {type: Function},
    },
    data() {
      return {
        id: 0,
        patentStatusName: '',
      }
    },
    methods: {
      showInfo(id) {  
        this.$refs['patentStatusFormModal'].show() 
        this.id = id
        const data = {id: this.id}
        const controller = {name : 'PatentStatus'}
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if(response.data.resultStatus == true){
                this.patentStatusName = response.data.patentStatus.name
            } else {
                this.$bvModal.hide('patentStatusFormModal')
                this.$WarningAlert(response.data.resultMessage)
            }  
        })  
      },
      addOrUpdate() {
        const data = {id: this.id, name: this.patentStatusName}
        const controller = {name : 'PatentStatus'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save',payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('patentStatusFormModal')
                    this.getPatentStatusList()
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
  